<template>
  <div>
    <v-dialog v-model="dialog" width="600">
      <v-card>
        <v-card-text>
          <v-card-title class="px-0">{{ $t("listOfVisits") }}</v-card-title>
          <template v-if="listGiven.length">
            <div
              v-for="(item, index) in listGiven"
              :key="`listGiven-${index}`"
              class="py-1"
            >
              <v-sheet
                min-height="42"
                class="rounded px-2 d-flex align-center justify-space-between"
                color="primary"
                dark
              >
                <span>
                  {{ index + 1 }}. {{ $t("date") }}:
                  {{ item.guessedTakenAwayDate | dateParse }};
                  {{ $t("count") }}: {{ item.count }}</span
                >
                <span v-show="item.state">{{
                  $t(`receptionStatus.${RECEPTION_STATUS[item.state]}`)
                }}</span>
                <downloader
                  v-if="item.filePath"
                  class="flex-shrink-0"
                  btn-class="btt"
                  :address="item.filePath"
                />
              </v-sheet>
            </div>
          </template>
          <span v-else>{{ $t("$vuetify.noDataText") }}</span>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Downloader from "@/components/ui/downloader";

const RECEPTION_STATUS = {
  NEW: "NEW",
  REQUEST_DONE: "REQUEST_DONE",
};

export default {
  name: "OmtkReceptionDialogList",
  components: { Downloader },
  data() {
    return {
      /**
       * @type Array<{filePath: string}>
       */
      listGiven: [],
      dialog: false,
      loading: false,
    };
  },
  methods: {
    close() {
      this.dialog = false;
      this.listGiven = [];
    },
    async visibleNotification(id, orderIndex, orderItemIndex) {
      try {
        await this.$http.post(`produce-history/mark-as-seen/${id}`);
        this.$emit("change-notify", { orderIndex, orderItemIndex });
      } catch (e) {
        this.setResponseError({ error: e });
      }
    },
    async open({ id, orderIndex, orderItemIndex }) {
      try {
        this.showLoading();
        this.visibleNotification(id, orderIndex, orderItemIndex).then();
        const {
          data: { data },
        } = await this.$http.get("produce-history/list", {
          params: { orderItemId: id },
        });

        this.listGiven = data;
        this.dialog = true;
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
  },
  computed: {
    RECEPTION_STATUS: () => RECEPTION_STATUS,
  },
};
</script>
